import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import styles from "./Container.module.scss";
export const Container = ({ children, className, dataTestId }) => {
    return (_jsx("div", { "data-testid": dataTestId || "container", className: classnames(styles.container, className), children: children }));
};
//# sourceMappingURL=Container.js.map